import * as React from "react";
import {useState} from "react";
import {VirtualServer} from "../../types/clients";

type Props = {
  virtualServers: ReadonlySet<VirtualServer>,
  addVirtualServerClicked: (value: string) => boolean,
  removeVirtualServerClicked: (value: string) => void
}

export default function VirtualServersGrid(props: Props): JSX.Element {
  const [newVirtualServerId, setNewVirtualServerId] = useState<string>('');

  const addVirtualServerClicked = () => {
    const result = props.addVirtualServerClicked(newVirtualServerId)

    if(result) {
      setNewVirtualServerId('');
    }
  }

  const handleVirtualServerInputKeyDown: (
    event: React.KeyboardEvent<HTMLInputElement>,
  ) => void = (event): void => {
    if (event.key === 'Enter') {
     addVirtualServerClicked()
    }
  }

  return (
    <div className='manage-virtual-servers-grid'>
      <input
        className='input no-margin-bottom'
        placeholder='Server ID'
        value={newVirtualServerId}
        onChange={(event) => setNewVirtualServerId(event.currentTarget.value)}
        onKeyDown={handleVirtualServerInputKeyDown}
      />
      <button
        className='button no-margin-top'
        onClick={addVirtualServerClicked}
        type='button'
      >
        Add Virtual Server
      </button>
      {[...props.virtualServers].map(value => {
        return (
          <React.Fragment key={value.id.toString()}>
            <label>{value.serverId}</label>
            <button
              className='button no-margin-top'
              value={value.id.toString()}
              onClick={(event) => props.removeVirtualServerClicked(event.currentTarget.value)}
              type='button'
            >
              Remove Virtual Server
            </button>
          </React.Fragment>
        )
      })}
    </div>
  )
}
